import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EncryptService } from '../encrypt/encrypt.service';
import { LoginRequest } from 'src/app/shared/login.request';
import { LoginResponse } from '../../shared/login.response';
import { AccReqRequest } from '../../shared/accReq.request';
import { ProvideNameRequest } from '../../shared/provideName.request';
import { GetUserRequest } from '../../shared/getUser.request';
import { GetUserResponse } from '../../shared/getUser.response';
import { ActiveUserRequest } from '../../shared/activeUser.request';
import { ActiveUserResponse } from '../../shared/activeUser.response';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public approvedUser = new BehaviorSubject<string | undefined>(undefined);
  public token: string;

  constructor(
    private http: HttpClient,
    private encryptService: EncryptService
  ) {
  }

  public login(req: any, recaptchaResponse: string, dataLogs: any): Promise<LoginResponse> {
    const strReq = JSON.stringify(req);
    const encrypted = this.encryptService.encrypt(strReq);
    const headers = new HttpHeaders().set('recaptcha', recaptchaResponse);
    const data = {
      encrypted,
      publicKey: this.encryptService.getPublicKey(),
      dataLogs
    };

    return this.http.post<LoginResponse>(`${environment.API_URL}auth/login`, data, { headers }).toPromise<LoginResponse>();
  }

  public accountRequest(req: AccReqRequest, recaptchaResponse: string): Promise<any> {
    const headers = new HttpHeaders().set('recaptcha', recaptchaResponse);
    return this.http.post(`${environment.API_URL}auth/solicitud`, req, { headers }).toPromise();
  }

  public provideName(req: ProvideNameRequest): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', `Api-Key ${environment.BACKEND_API_KEY}`);
    return this.http.post(`${environment.API_URL}auth/provideName`, req, { responseType: 'text', headers }).toPromise();
  }

  public getUser(req: GetUserRequest): Promise<GetUserResponse> {
    const headers = new HttpHeaders().set('Authorization', `Api-Key ${environment.BACKEND_API_KEY}`);
    const strReq = JSON.stringify(req);
    const encrypted = this.encryptService.encrypt(strReq);
    const data = {
      encrypted,
      publicKey: this.encryptService.getPublicKey()
    };
    return this.http.post<GetUserResponse>(`${environment.API_URL}auth/getUserV2`, data, { headers })
      .toPromise<GetUserResponse>();
  }

  public activeUser(req: ActiveUserRequest): Promise<ActiveUserResponse> {
    const headers = new HttpHeaders().set('Authorization', `Api-Key ${environment.BACKEND_API_KEY}`);
    const strReq = JSON.stringify(req);
    const encrypted = this.encryptService.encrypt(strReq);
    const data = {
      encrypted,
      publicKey: this.encryptService.getPublicKey()
    };
    return this.http.patch<ActiveUserResponse>(`${environment.API_URL}auth`, data, { headers })
      .toPromise<ActiveUserResponse>();
  }

  public pair(): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', `Api-Key ${environment.BACKEND_API_KEY}`);
    return this.http.get(`${environment.API_URL}auth/getkey`, { responseType: 'text', headers }).toPromise();
  }

  public getIp(): Promise<any> {
    return this.http.get(`http://api.ipify.org/?format=json`, {}).toPromise();
  }

  public recoverPassword(req: any, recaptchaResponse: string): Promise<any> {
    const headers = new HttpHeaders().set('recaptcha', recaptchaResponse);
    return this.http.post<any>(`${environment.API_URL}auth/recuperarContrasena`, req, { headers }).toPromise<any>();
  }

  public createNewPassword(req: any): Promise<any> {
    const headers = new HttpHeaders().set('Authorization', `Api-Key ${environment.BACKEND_API_KEY}`);
    const strReq = JSON.stringify(req);
    const encrypted = this.encryptService.encrypt(strReq);

    const data = {
      encrypted,
      publicKey: this.encryptService.getPublicKey()
    };

    return this.http.post<any>(`${environment.API_URL}auth/reestablecerContrasena`, data, { headers }).toPromise<any>();
  }
}
